import type React from 'react';
import { useMemo, useState } from 'react';

import { inputStyle as inputStyleClass } from './Survey.css';
import type { QuestionOption } from './Survey.types';
import { getInputStyle } from './utils';

interface SelectProps {
  name: string;
  options: QuestionOption[];
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  inputStyle?: React.CSSProperties;
}

const Select: React.FC<SelectProps> = ({
  name,
  options,
  defaultValue,
  placeholder = 'Please select a value',
  disabled = false,
  required = false,
  inputStyle = {},
}) => {
  const style = useMemo(() => getInputStyle(inputStyle), [inputStyle]);
  const [value, setValue] = useState(defaultValue);

  return (
    <select
      name={name}
      defaultValue={defaultValue}
      onChange={(e) => setValue(e.target.value)}
      disabled={disabled}
      required={required}
      style={style}
      className={inputStyleClass}
      data-placeholder-selected={!value || value === ''}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.id} value={option.value}>
          {option.value}
        </option>
      ))}
    </select>
  );
};

export default Select;
